import http from './http';
import demoData from '../mock/demoData';

const isDemo = () => sessionStorage.getItem('sas_demo') === '1';
const read = (key, request) => isDemo() ? Promise.resolve(demoData[key]) : request();
const write = (request) => isDemo() ? Promise.reject({ userMessage: '演示模式仅供浏览，保存操作已禁用' }) : request();

const api = {
  demoActor: demoData.actor,
  login: ({ username, password }) => http.post('/api/auth/login', { username, password }),
  me: () => http.get('/api/auth/me'),
  logout: () => isDemo() ? Promise.resolve() : http.post('/api/auth/logout'),
  password: (data) => write(() => http.post('/api/auth/password', data)),
  dashboard: () => read('dashboard', () => http.get('/api/dashboard/summary')),
  stores: (params) => read('stores', () => http.get('/api/stores', { params })),
  users: (params) => read('users', () => http.get('/api/users', { params })),
  user: (id) => isDemo() ? Promise.resolve(demoData.users.items.find((user) => user.id === id)) : http.get(`/api/users/${id}`),
  roles: (params) => read('roles', () => http.get('/api/roles', { params })),
  permissionsTree: () => read('permissions', () => http.get('/api/permissions/tree')),
  createStore: (data) => write(() => http.post('/api/stores', data)),
  updateStore: (id, data) => write(() => http.put(`/api/stores/${id}`, data)),
  deleteStore: (id) => write(() => http.delete(`/api/stores/${id}`)),
  uploadLogo: (storeId, file) => write(() => {
    const data = new FormData();
    data.append('store_id', String(storeId));
    data.append('file', file);
    return http.post('/api/uploads/logo', data);
  }),
  createRole: (data) => write(() => http.post('/api/roles', data)),
  updateRole: (id, data) => write(() => http.put(`/api/roles/${id}`, data)),
  deleteRole: (id) => write(() => http.delete(`/api/roles/${id}`)),
  createUser: (data) => write(() => http.post('/api/users', data)),
  updateUser: (id, data) => write(() => http.put(`/api/users/${id}`, data)),
  deleteUser: (id) => write(() => http.delete(`/api/users/${id}`)),
  aiSettings: () => read('aiSettings', () => http.get('/api/ai/settings')),
  updateAiSettings: (data) => write(() => http.put('/api/ai/settings', data)),
  aiUsage: (params) => read('aiUsage', () => http.get('/api/ai/usage', { params })),
  updateAiUsageLimit: (id, token_limit) => write(() => http.put(`/api/ai/usage/${id}/limit`, { token_limit })),
  storageSettings: () => read('storageSettings', () => http.get('/api/storage/settings')),
  updateStorageSettings: (data) => write(() => http.put('/api/storage/settings', data)),
  storageUsage: (params) => read('storageUsage', () => http.get('/api/storage/usage', { params })),
  updateStorageQuota: (id, quota_gb) => write(() => http.put(`/api/storage/usage/${id}/quota`, { quota_gb })),
  storageObjects: (params) => http.get('/api/storage/objects', { params }),
  uploadStorage: (file) => write(() => { const data = new FormData(); data.append('file', file); return http.post('/api/storage/upload', data); }),
  deleteStorageObject: (id) => write(() => http.delete(`/api/storage/objects/${id}`)),
  products: (params) => read('products', () => http.get('/api/products', { params })),
  product: (id) => isDemo() ? Promise.resolve((demoData.products.items || []).find((item) => item.id === id)) : http.get(`/api/products/${id}`),
  createProduct: (data) => write(() => http.post('/api/products', data)),
  updateProduct: (id, data) => write(() => http.put(`/api/products/${id}`, data)),
  deleteProduct: (id) => write(() => http.delete(`/api/products/${id}`)),
  productSeries: (params) => read('productSeries', () => http.get('/api/product-series', { params })),
  createProductSeries: (data) => write(() => http.post('/api/product-series', data)),
  updateProductSeries: (id, data) => write(() => http.put(`/api/product-series/${id}`, data)),
  deleteProductSeries: (id) => write(() => http.delete(`/api/product-series/${id}`)),
  uploadProductSeriesImage: (id, file) => write(() => { const data = new FormData(); data.append('file', file); return http.post(`/api/product-series/${id}/image`, data); }),
  deleteProductSeriesImage: (id) => write(() => http.delete(`/api/product-series/${id}/image`)),
  productFields: (params) => read('productFields', () => http.get('/api/product-fields', { params })),
  createProductField: (data) => write(() => http.post('/api/product-fields', data)),
  updateProductField: (id, data) => write(() => http.put(`/api/product-fields/${id}`, data)),
  deleteProductField: (id) => write(() => http.delete(`/api/product-fields/${id}`)),
  uploadProductAsset: (id, file) => write(() => { const data = new FormData(); data.append('file', file); return http.post(`/api/products/${id}/assets`, data); }),
  deleteProductAsset: (id) => write(() => http.delete(`/api/products/assets/${id}`))
  ,businessQueryModels: () => read('businessQueryModels', () => http.get('/api/business-query/models')),
  createBusinessQueryModel: (data) => write(() => http.post('/api/business-query/models', data)),
  updateBusinessQueryModel: (id, data) => write(() => http.put(`/api/business-query/models/${id}`, data)),
  deleteBusinessQueryModel: (id) => write(() => http.delete(`/api/business-query/models/${id}`)),
  businessQuery: (data) => write(() => http.post('/api/business-query/search', data)),
  businessQueryHistory: () => read('businessQueryHistory', () => http.get('/api/business-query/history'))
  ,downloadProductImages: (id) => http.get(`/api/products/${id}/images/download`, { responseType: 'blob' })
};

// Selectors must include stores beyond the first page of the management table.
api.allStores = async () => {
  const items = [];
  let page = 1;
  let total = Infinity;
  while (items.length < total) {
    const result = await api.stores({ page, per_page: 100 });
    const rows = result.items || result || [];
    items.push(...rows);
    total = result.total === undefined ? items.length : result.total;
    if (!rows.length || isDemo()) break;
    page += 1;
  }
  return items;
};
export default api;

